<div class="fe-header-container theme-{{theme}}">
  <ng-content></ng-content>
</div>
